import { $win, $body } from "../utils/globals";
import isMobile from '../utils/isMobile';

$("header nav").on("click", "a, h3", function(e) {
  let parentEl = $(this).closest("li");
  let subMenu = $(this).closest("li").children("div, ul");

  parentEl.siblings().removeClass("is-hovered");

  if ( !parentEl.hasClass("is-hovered") && isMobile.any() && $win.width() <= 1024 && subMenu.length > 0 ) {
    e.preventDefault();

    parentEl.addClass("is-hovered");
  }
});
